module.exports = __webpack_public_path__ + "img/reset1.af658b2b.svg";